const TOAST = (toast) =>
    `<div
        x-data="toast_component(${ JSON.stringify(toast).replace(/"/g, "'") })"
        class="toast flex gap-2 min-w-80 max-w-96 py-2 px-4 border transition-opacity duration-300"
        x-show="toast.show"
        x-transition:enter="transition ease-out duration-300"
        x-transition:enter-start="opacity-0"
        x-transition:enter-end="opacity-100"
        x-transition:leave="transition ease-in duration-300"
        x-transition:leave-start="opacity-100"
        x-transition:leave-end="opacity-0"
        x-init="setTimeout(() => removeToast(toast.id), 5000)"
        :data-toast-type="toast.type"
    >
        <div>
            <svg class="w-5 h-5">
                <use :href="'/svg/sprites.svg#icon-' + toast.icon"></use>
            </svg>
        </div>
        <div class="grow">
            <p x-text="toast.title"></p>
            <p class="text-sm" x-html="toast.message ?? ''"></p>
        </div>
        <button @click="removeToast(toast.id)">
            <svg class="w-4 h-4">
                <use href="/svg/sprites.svg#icon-cancel"></use>
            </svg>
        </button>
    </div>`;

const VALID_TYPES = ['success', 'info', 'error', 'warning'];

export default () => ({
    /**
     * @param { title: string, message?: string, type: 'success' | 'info' | 'error' | 'warning'} toast
     */
    addToast(toast) {

        if (!toast.title || !toast.type || !VALID_TYPES.includes(toast.type))
            throw new Error('The toast must have a title, body, and a valid type (success, info, error, warning).', toast);

        toast.show = true;

        switch (toast.type) {
            case 'success':
                toast.icon = 'check';
                break;

            case 'info':
                toast.icon = 'info';
                break;

            case 'warning':
                toast.icon = 'warning';
                break;

            case 'error':
                toast.icon = 'error';
                break;

            default:
                throw new Error('Invalid toast type')
        }

        const toastHTML = TOAST(toast);
        this.$el.insertAdjacentHTML('beforeend', toastHTML);
    },
});
